import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Field, reduxForm, reset } from 'redux-form';
import validate from './validate';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { gql } from '@apollo/client';
import { flowRight as compose } from 'lodash';
import Button from 'react-bootstrap/lib/Button';
import FormControl from 'react-bootstrap/lib/FormControl';
import Col from 'react-bootstrap/lib/Col';
import FormGroup from 'react-bootstrap/lib/FormGroup';

import messages from '../../../locale/messages';
import { closeWishListGroupModal } from '../../../actions/WishList/modalActions';
import getAllWishListGroupQuery from '../getAllWishListGroup.graphql';
import showToaster from '../../../helpers/showToaster';
import { withMutation } from '../../../hoc/withGraphql';

import s from './WishListGroupForm.css';
import bt from '../../../components/commonStyle.css';


const renderFormControl = ({ input, label, type, meta: { touched, error }, className, placeholder,formatMessage }) => {
  return (
    <FormGroup className={bt.space4}>
      <FormControl {...input} placeholder={placeholder} type={type} className={className} />
      {touched && error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
    </FormGroup>
  );
}

const AddWishListGroupForm = ({ valid, mutate, error, handleSubmit }) => {
  const { formatMessage } = useIntl();

  const profileId = useSelector(state => state.account.data.profileId);
  const dispatch = useDispatch()

  const submitForm = async (values) => {
    const { data } = await mutate({
      variables: values,
      refetchQueries: [{
        query: getAllWishListGroupQuery,
        variables: {
          profileId
        }
      }]
    });
    if (data && data.CreateWishListGroup) {
      if (data.CreateWishListGroup.status === 'success') {
        dispatch(reset('AddWishListGroupForm'));
        dispatch(closeWishListGroupModal());
        showToaster({ messageId: 'addWishlist', toasterType: 'success' })
      } else {
        showToaster({ messageId: 'commonError', toasterType: 'error' })
      }
    }
  }

  return (
    <div className={'inputFocusColor'}>
      <form onSubmit={handleSubmit(submitForm)}>
        {error && <strong>{formatMessage(error)}</strong>}

        <Field
          name="name"
          type="text"
          component={renderFormControl}
          placeholder={formatMessage(messages.name)}
          className={cx(bt.commonControlInput)}
          formatMessage={formatMessage}
        />
        <div className='doubleBtnFlexEnd'>
          <Button className={bt.btnPrimary} type="submit" disabled={!valid}>
            {formatMessage(messages.save)}
          </Button>
          <a onClick={() => dispatch(closeWishListGroupModal())} className={bt.btnPrimaryBorder} > {formatMessage(messages.deSelect)}</a>
        </div>
      </form>
    </div>
  )
}

AddWishListGroupForm.propTypes = {
  fieldType: PropTypes.string,
  formatMessage: PropTypes.any
};

export default compose(
  withStyles(s, bt),
  reduxForm({
    form: "AddWishListGroupForm", // a unique name for this form
    validate,
  }),
  withMutation(gql`
    mutation CreateWishListGroup(
      $name: String!,
      $isPublic: String,
    ){
        CreateWishListGroup(
          name: $name,
          isPublic: $isPublic
        ) {
            status
        }
    }
  `)
)(AddWishListGroupForm);
